import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-8d3bf910")
const _hoisted_1 = { class: "modal" }
const _hoisted_2 = { class: "flex w-full items-center justify-between" }
const _hoisted_3 = { class: "flex w-full items-center" }
const _hoisted_4 = { class: "flex-none" }
const _hoisted_5 = { class: "flex w-full justify-between pr-[22px] pl-[18px] pt-[14px] pb-[24px]" }
const _hoisted_6 = {
  key: 0,
  class: "font-semibold"
}
const _hoisted_7 = { class: "mr-[25px]" }
const _hoisted_8 = { class: "flex items-center ml-2" }
const _hoisted_9 = { class: "mr-1" }
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "text-[14px] color-[#BDB2DD] text-secondary" }
const _hoisted_12 = {
  key: 0,
  class: "h-96 overflow-y-scroll py-[24px]"
}
const _hoisted_13 = ["textContent"]
const _hoisted_14 = { class: "flex" }
const _hoisted_15 = { class: "px-[16px] pb-[12px] pt-[24px]" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "common-bases-title mb-[12px]" }, "Common bases", -1)
const _hoisted_17 = { class: "flex gap-[8px] overflow-hidden" }
const _hoisted_18 = { class: "common-asset flex items-center" }
const _hoisted_19 = { class: "token-name" }
const _hoisted_20 = { class: "common-asset flex items-center" }
const _hoisted_21 = { class: "token-name" }
const _hoisted_22 = { class: "common-asset flex items-center" }
const _hoisted_23 = { class: "token-name" }
const _hoisted_24 = { class: "common-asset flex items-center" }
const _hoisted_25 = { class: "token-name" }
const _hoisted_26 = { class: "common-asset flex items-center" }
const _hoisted_27 = { class: "token-name" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "m-[12px] border" }, null, -1)
const _hoisted_29 = { class: "overflow-hidden rounded-lg" }
const _hoisted_30 = ["onClick"]
const _hoisted_31 = {
  key: 1,
  class: "flex h-[530px] items-center justify-center"
}
const _hoisted_32 = ["textContent"]
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BalIcon = _resolveComponent("BalIcon")!
  const _component_BalBtn = _resolveComponent("BalBtn")!
  const _component_x = _resolveComponent("x")!
  const _component_Search = _resolveComponent("Search")!
  const _component_TokenListsListItem = _resolveComponent("TokenListsListItem")!
  const _component_BalAsset = _resolveComponent("BalAsset")!
  const _component_TokenListItem = _resolveComponent("TokenListItem")!
  const _component_RecycleScroller = _resolveComponent("RecycleScroller")!
  const _component_BalLoadingIcon = _resolveComponent("BalLoadingIcon")!
  const _component_BalModal = _resolveComponent("BalModal")!

  return (_openBlock(), _createBlock(_component_BalModal, {
    show: "",
    noContentPad: "",
    onClose: _cache[9] || (_cache[9] = ($event: any) => (_ctx.$emit('close')))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              (_ctx.selectTokenList)
                ? (_openBlock(), _createBlock(_component_BalBtn, {
                    key: 0,
                    color: "transparent",
                    size: "xs",
                    class: "mr-2 back",
                    circle: "",
                    onClick: _ctx.onListExit
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_BalIcon, {
                        name: "arrow-left",
                        size: "sm"
                      })
                    ]),
                    _: 1
                  }, 8, ["onClick"]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_5, [
              (!_ctx.selectTokenList)
                ? (_openBlock(), _createElementBlock("h6", _hoisted_6, "Select a list"))
                : _createCommentVNode("", true),
              (!_ctx.selectTokenList)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    class: "group flex items-center cursor-pointer",
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleSelectTokenList && _ctx.toggleSelectTokenList(...args)))
                  }, [
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("span", _hoisted_9, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activeTokenLists, (tokenlist, i) => {
                            return (_openBlock(), _createElementBlock("img", {
                              key: i,
                              src: _ctx.resolve(tokenlist.logoURI),
                              class: "inline-block w-4 h-4 bg-white rounded-full shadow"
                            }, null, 8, _hoisted_10))
                          }), 128))
                        ]),
                        _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.$t('tokenLists')), 1),
                        _createVNode(_component_BalIcon, {
                          name: "chevron-right",
                          size: "sm",
                          class: "ml-1 text-white-500 group-hover:text-white-500 group-focus:text-white-500 transition-all duration-200 ease-out",
                          style: {"margin-top":"0px"}
                        })
                      ])
                    ]),
                    _createVNode(_component_x, {
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
                    })
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        (_ctx.selectTokenList)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              (!_ctx.selectTokenList)
                ? (_openBlock(), _createBlock(_component_Search, {
                    key: 0,
                    modelValue: _ctx.query,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.query = $event)),
                    placeholder: _ctx.$t('Search name or paste address'),
                    class: "flex-auto px-[16px] search-token"
                  }, null, 8, ["modelValue", "placeholder"]))
                : _createCommentVNode("", true),
              _createElementVNode("div", null, [
                (Object.keys(_ctx.tokenLists).length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tokenLists, (tokenList, uri) => {
                        return (_openBlock(), _createBlock(_component_TokenListsListItem, {
                          key: uri,
                          isActive: _ctx.isActiveList(uri),
                          tokenlist: tokenList,
                          uri: uri,
                          onToggle: ($event: any) => (_ctx.onToggleList(uri))
                        }, null, 8, ["isActive", "tokenlist", "uri", "onToggle"]))
                      }), 128))
                    ]))
                  : (_openBlock(), _createElementBlock("div", {
                      key: 1,
                      class: "flex h-96 items-center justify-center",
                      textContent: _toDisplayString(_ctx.$t('errorNoLists'))
                    }, null, 8, _hoisted_13))
              ])
            ], 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createElementVNode("div", _hoisted_14, [
                _createVNode(_component_Search, {
                  modelValue: _ctx.query,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.query = $event)),
                  placeholder: _ctx.$t('Search name or paste address'),
                  class: "flex-auto px-[16px] border-0"
                }, null, 8, ["modelValue", "placeholder"])
              ]),
              _createElementVNode("div", _hoisted_15, [
                _hoisted_16,
                _createElementVNode("div", _hoisted_17, [
                  (_ctx.tokens[2])
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onSelectToken(_ctx.tokens[2].address))),
                        class: "flex-none"
                      }, [
                        _createElementVNode("div", _hoisted_18, [
                          _createVNode(_component_BalAsset, {
                            address: _ctx.tokens[2].address,
                            iconURI: _ctx.tokens[2].logoURI,
                            size: 24,
                            class: "mr-[4px]"
                          }, null, 8, ["address", "iconURI"]),
                          _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.tokens[2].symbol), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.tokens[1])
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 1,
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.onSelectToken(_ctx.tokens[1].address))),
                        class: "flex-none"
                      }, [
                        _createElementVNode("div", _hoisted_20, [
                          _createVNode(_component_BalAsset, {
                            address: _ctx.tokens[1].address,
                            iconURI: _ctx.tokens[1].logoURI,
                            size: 24,
                            class: "mr-[4px]"
                          }, null, 8, ["address", "iconURI"]),
                          _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.tokens[1].symbol), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.tokens[4])
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 2,
                        onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.onSelectToken(_ctx.tokens[4].address))),
                        class: "flex-none"
                      }, [
                        _createElementVNode("div", _hoisted_22, [
                          _createVNode(_component_BalAsset, {
                            address: _ctx.tokens[4].address,
                            iconURI: _ctx.tokens[4].logoURI,
                            size: 24,
                            class: "mr-[4px]"
                          }, null, 8, ["address", "iconURI"]),
                          _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.tokens[4].symbol), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.isDesktop)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                        (_ctx.tokens[3])
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 0,
                              onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.onSelectToken(_ctx.tokens[3].address))),
                              class: "flex-none"
                            }, [
                              _createElementVNode("div", _hoisted_24, [
                                _createVNode(_component_BalAsset, {
                                  address: _ctx.tokens[3].address,
                                  iconURI: _ctx.tokens[3].logoURI,
                                  size: 24,
                                  class: "mr-[4px]"
                                }, null, 8, ["address", "iconURI"]),
                                _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.tokens[3].symbol), 1)
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.tokens[0])
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 1,
                              onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.onSelectToken(_ctx.tokens[0].address))),
                              class: "flex-none"
                            }, [
                              _createElementVNode("div", _hoisted_26, [
                                _createVNode(_component_BalAsset, {
                                  address: _ctx.tokens[0].address,
                                  iconURI: _ctx.tokens[0].logoURI,
                                  size: 24,
                                  class: "mr-[4px]"
                                }, null, 8, ["address", "iconURI"]),
                                _createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.tokens[0].symbol), 1)
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ], 64))
                    : _createCommentVNode("", true)
                ])
              ]),
              _hoisted_28,
              _createElementVNode("div", _hoisted_29, [
                (_ctx.tokens.length > 0)
                  ? (_openBlock(), _createBlock(_component_RecycleScroller, {
                      key: 0,
                      class: "h-[530px] overflow-y-scroll py-[24px]",
                      items: _ctx.tokens,
                      itemSize: 64,
                      keyField: "address",
                      buffer: 100
                    }, {
                      default: _withCtx(({ item: token }) => [
                        _createElementVNode("a", {
                          onClick: ($event: any) => (_ctx.onSelectToken(token.address))
                        }, [
                          _createVNode(_component_TokenListItem, {
                            token: token,
                            balanceLoading: _ctx.dynamicDataLoading
                          }, null, 8, ["token", "balanceLoading"])
                        ], 8, _hoisted_30)
                      ]),
                      _: 1
                    }, 8, ["items"]))
                  : (_ctx.loading)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                        _createVNode(_component_BalLoadingIcon)
                      ]))
                    : (_openBlock(), _createElementBlock("div", {
                        key: 2,
                        class: "text-secondary h-[530px] text-center",
                        textContent: _toDisplayString(_ctx.$t('errorNoTokens'))
                      }, null, 8, _hoisted_32))
              ])
            ], 64))
      ])
    ]),
    _: 1
  }))
}